import React from 'react';

import { Col, Row } from 'antd';
import { Amount } from '~/types';
import { AmountField } from '~/components';
import styled from 'styled-components';
import theme from '~/theme';

interface Props {
  title: JSX.Element;
  subtitle: JSX.Element;
  icon?: JSX.Element;
  suffix?: JSX.Element;
  amount?: Amount;
  className?: string;
}

const AccountAutocompleteItem = (props: Props) => {
  const { title, subtitle, icon, amount, className, suffix } = props;
  return (
    <Row gutter={[8, 0]} wrap={false} align="middle" className={className}>
      {icon && <Col flex="36px">{icon}</Col>}
      <Col flex="auto">
        <div className="Title">{title}</div>
        <div className="Subtitle">{subtitle}</div>
      </Col>
      {amount && (
        <Col>
          <AmountField className="Amount" amount={amount} />
        </Col>
      )}
      {suffix && (
        <Col>
          {suffix}
        </Col>
      )}
    </Row>
  );
};

export default styled(AccountAutocompleteItem)`
  width: 100%;
  .Title {
    margin-top: 1px;
  }
  .Subtitle {
    color: ${theme.disabledColor};
    font-size: 80%;
    line-height: 1em;
    padding-bottom: 4px;
  }
  .Title {
    overflow: hidden;
    white-space: nowrap;
    text-wrap: nowrap;
    text-overflow: ellipsis;
  }
  .Amount {
    padding-right: 4px;
    font-size: 120%;
    font-weight: bold;
  }
`;
